/* GET SF FILTERS */
export const GET_ADMIN_SF_FILTERS = "GET_ADMIN_SF_FILTERS"
export const GET_ADMIN_SF_FILTERS_SUCCESS = "GET_ADMIN_SF_FILTERS_SUCCESS"
export const GET_ADMIN_SF_FILTERS_ERROR = "GET_ADMIN_SF_FILTERS_ERROR"

/* CREATE SF FILTER */
export const CREATE_ADMIN_SF_FILTER = "CREATE_ADMIN_SF_FILTER"
export const CREATE_ADMIN_SF_FILTER_SUCCESS = "CREATE_ADMIN_SF_FILTER_SUCCESS"
export const CREATE_ADMIN_SF_FILTER_ERROR = "CREATE_ADMIN_SF_FILTER_ERROR"

/* UPDATE SF FILTER */
export const UPDATE_ADMIN_SF_FILTER = "UPDATE_ADMIN_SF_FILTER"
export const UPDATE_ADMIN_SF_FILTER_SUCCESS = "UPDATE_ADMIN_SF_FILTER_SUCCESS"
export const UPDATE_ADMIN_SF_FILTER_ERROR = "UPDATE_ADMIN_SF_FILTER_ERROR"

/* DELETE SF FILTER */
export const DELETE_ADMIN_SF_FILTER = "DELETE_ADMIN_SF_FILTER"
export const DELETE_ADMIN_SF_FILTER_SUCCESS = "DELETE_ADMIN_SF_FILTER_SUCCESS"
export const DELETE_ADMIN_SF_FILTER_ERROR = "DELETE_ADMIN_SF_FILTER_ERROR"